/**
 * @typedef {import('./Props').default} Props
 * @typedef {import('./State').default} State
 */

import { translate } from 'App/Internationalization';
import React from 'react';

export default class Movers extends React.Component {
	/** @returns {string} */
	static #getTenant() {
		const host = window.location.hostname.toLowerCase();
		if (host.includes('simplyhome')) {
			return translate('global.tenants.simplyhome');
		}
		return translate('global.tenants.homekeepr'); // safe default
	}

	/**
	 * @returns {JSX.Element}
	 */
	/* eslint-disable class-methods-use-this -- Render method must be invokable by `this` */
	render() {
		// const likely = this.state.likelyPercentage.toString();
		return (
			<section className="md:flex justify-between mt-2">
				<article className="mr-4">
					<div className="h-ms-3">
						{translate(
							'agent.pages.dashboard.movers.labels.Avmlikely'
						)}
					</div>
					<div
						className="text-sm my-4"
						// eslint-disable-next-line react/no-danger
						dangerouslySetInnerHTML={{
							__html: translate(
								'agent.pages.dashboard.movers.upgraded.Avmlikely_description',
								Movers.#getTenant(),
								Movers.#getTenant()
							),
						}}
					/>
				</article>
				{/* <figure className="graph">
					<BaseDonutChart
						data={this.#data}
						hideInnerText={false}
						text={this.state.chartText}
					/>
				</figure> */}
			</section>
		);
	}
}
